import React, { useEffect } from "react";
import { Translate } from "../../utils/Translate";
import { Typography, Grid, Select, MenuItem } from "@material-ui/core";
import Routes from "../Router/Routes"
import Config from "../../assets/config.json"
// const config = require("../config.json")
// 3rd Dec,2019 by Nikhil
// Expected latest Design
// Commented the code for adding these items to the footer
function Footer(props) {
  const {language,copyright,supportedLanguages=[],langauageSelector=false} = Config;
  const version = localStorage.getItem("version");
  const [open, setOpen] = React.useState(false);
  useEffect(()=>{
    if(langauageSelector){
      const selectedLanguage = localStorage.getItem("language");
      if(!supportedLanguages.includes(selectedLanguage)){
        localStorage.setItem("language",language);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);
  const languageValues =  supportedLanguages.map((items)=>{
    const id = "language."+items;
    return Translate({ id,defaultMessage:items,values:items })
  });
  const handleChange = (event) => {
    localStorage.setItem("language",event.target.value);
    window.location.reload();
  };

  const copyrightValue =()=>{
    const currentYear = new Date().getFullYear()
    return copyright ?? `© Connected Fitness Labs ${currentYear}.` //fallback in case api doesn't pass value
  }
  return (
    <footer className="Footer">
      <div className="alignleft">
      {langauageSelector && supportedLanguages.length &&
      <>
      <Typography variant="h3">
          <a href={Routes.homePage}>{Translate({ id: "labelforlanguageswitcher.SiteLanguageLabel" })}</a>
          &nbsp;|&nbsp;
          <Select
          labelId="langauage-selector-label"
          id="langauage-selector"
          open={open}
          onClose={()=>setOpen(false)}
          onOpen={()=>setOpen(true)}
          value={localStorage.getItem("language")}
          onChange={handleChange}
        >
          {supportedLanguages.map((suportedLanguage,index)=>
            <MenuItem className="langauage-switcher" value={suportedLanguage}>
              {languageValues[index] ?? suportedLanguage}
            </MenuItem>
          )}
        </Select>
      
        </Typography>
        </>
      }
        <Typography variant="h3">
          <a href={Routes.homePage}>{Translate({ id: "footer.home" })}</a>
        </Typography>
        <Typography variant="h3">
          <a href="/contact">{Translate({ id: "footer.contactUs" })}</a>
        </Typography>
        <Typography variant="h3">
          <a href="/tc">{Translate({ id: "footer.TermsAndConditions" })}</a>
        </Typography>
        <div className="clear">&nbsp;</div>
        
      </div>
      <Grid container>
        <Grid item lg={6} md={6} sm={6} xs={12}>
        <p className="text-white">{copyrightValue()}{" "}{Translate({ id: "footer.Copyright" })}</p>
        </Grid>
        <Grid item lg={6} md={6} sm={6} xs={12}>
        <p className="textLeft-xs text-white text-right">
        {Translate({ id: "footer.Build" })}{": "}
            {version} 
        </p>
        
        </Grid>
      </Grid>
    </footer>
  );
}

export default Footer;
